export { default } from './net-worth';
